import { Checkbox, Modal, Row, Col } from "antd";
import React, { useState } from "react";
import utils from "../../module/utils";

/**
 * 调整显示的列的模块，这里主要控制弹窗显示和弹窗内容，请传入所有列，筛选后的结果会在onChange中返回
 */
export default function ColumnCustomizer(props) {

    const { children, onChange, columnConfig } = props;

    const [showModal, updateShowModal] = useState(false);

    // 获取checkbox用的options
    function generateOptions() {
        let options = [];
        columnConfig.forEach((config, index) => {
            if (config.key == 0) { // 首先取出固定列
                let option = {
                    label: config.label,
                    value: config.name,
                    disabled: !config.allowChange
                };
                options.push(option);
            } else { // 然后处理可变列
                let option = {
                    label: config.label,
                    value: config.name,
                    disabled: !config.allowChange
                };
                options.push(option);
            }
        });
        // console.log(columnConfig, options)
        return options;
    };

    // 获取已设置为展示的选项的列表
    function getDefaultCheckedList() {
        let defaultChecked = [];
        columnConfig.forEach((config, index) => {
            if (config.key == 0 && config.display) { // 首先取出固定列
                defaultChecked.push(config.name);
            }
        });
        return defaultChecked;
    };

    // 修改config的display值
    function changeDisplay(newCheckedValueList) {
        let newConfig = columnConfig.map((config, index2) => {
            if (utils.contain(newCheckedValueList, config.name)) {
                config.display = true;
            } else {
                config.display = false;
            }
            return config;
        });
        onChange && onChange(newConfig);
    };

    return (
        <React.Fragment>
            <div style={{display: "inline-block"}} onClick={() => updateShowModal(true)} >
                {children}
            </div>
            <Modal
                title="Customize columns"
                open={showModal}
                onOk={() => {
                    updateShowModal(false);
                }}
                okText="Apply"
                onCancel={() => updateShowModal(false)}
                footer={null}
            >
                <Checkbox.Group
                    defaultValue={getDefaultCheckedList()}
                    onChange={(checkedValues) => changeDisplay(checkedValues)}
                >
                    <Row>
                        {generateOptions().map((option, index) => {
                            return (
                                <Col span={12} key={index} >
                                    <Checkbox value={option.value} >{option.label}</Checkbox>
                                </Col>
                            )
                        })}
                    </Row>
                </Checkbox.Group>
            </Modal>
        </React.Fragment>
    );
}